<template>
  <header>
    <nav class="navbar navbar-expand-lg navbar-light bg-dark p-3">
      <div class="container-fluid">
        <a class="navbar-brand text-light" href="#">Booking App</a>
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
    </nav>
  </header>

  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-8 col-sm-12 mt-5 mb-2">
        <router-link to="/bookingapp/fchq" class="btn btn-success w-100 fs-3 rounded-0">FCHQ</router-link>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-8 col-sm-12 mt-2 mb-2">
        <router-link to="/bookingapp/whitlam" class="btn btn-success w-100 fs-3 rounded-0">WHITLAM</router-link>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-8 col-sm-12 mt-2 mb-2">
        <router-link to="/bookingapp/futsal" class="btn btn-success w-100 fs-3 rounded-0">FUTSAL</router-link>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-8 col-sm-12 mt-2 mb-2">
        <router-link to="/bookingapp/tennis" class="btn btn-success w-100 fs-3 rounded-0">TENNIS</router-link>
      </div>
    </div>
    <!-- </div><div class="row justify-content-center">
      <div class="col-lg-6 col-md-8 col-sm-12 mt-2 mb-2">
        <router-link to="/bookingapp/c" class="btn btn-success w-100 fs-3 rounded-0">FCHQ CALENDAR</router-link>
      </div>
    </div> -->
    <div class="row justify-content-center">
      <div class="col-lg-6 col-md-8 col-sm-12 mt-2 mb-5">
        <router-link to="/bookingapp/whitlam-calendar" class="btn btn-success w-100 fs-3 rounded-0">WHITLAM CALENDAR</router-link>
      </div>
    </div>
    <!-- <div class="row justify-content-center">
      <div class="col-lg-6 col-md-8 col-sm-12 mt-2 mb-2">
        <router-link to="/bookingapp/futsal-calendar" class="btn btn-success w-100 fs-3 rounded-0">FUTSAL CALENDAR</router-link>
      </div>
    </div> -->
    <!-- <div class="row justify-content-center">
      <div class="col-lg-6 col-md-8 col-sm-12 mt-2 mb-5">
        <router-link to="/bookingapp/tennis-calendar" class="btn btn-success w-100 fs-3 rounded-0">TENNIS CALENDAR</router-link>
      </div>
    </div> -->
  </div>

  <footer class="text-center text-lg-start bg-dark text-muted">
    <div class="text-center text-light p-4">
      Copyright @ 2023 Fairfield City Council. All rights reserved.
    </div>
  </footer>
</template>

<script>
export default {
  name: 'HomeIndex',
  data() {
    return {
    }
  },
  mounted() {
      // console.log(process.env.APP_ENV)
  }
}
</script>